export class ResponseError extends Error {
  constructor(message: string, response: {[key: string]: string}, options?: ErrorOptions) {
    super(message, options);
    this.response = response;
  }

  response: {[key: string]: string} | null = null;
}